import React, { useContext } from "react";
import { ThemeContext } from "../../../utills/ThemeContext";
import styles from "./ThemeColor.module.css";
import TextComponent from "../../../components/textComponent/TextComponent";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";

const ThemeColor = () => {
  const { theme, setTheme } = useContext(ThemeContext);

  // Default theme colors
  const defaultTheme = {
    primary: "#AB3006",
    // secondary: "linear-gradient(88.43deg, #FA9145 2.67%, #C5532D 96.44%)",
    menuactive: "#F9A826",
  };

  const handleChange = (e) => {
    setTheme({ ...theme, [e.target.name]: e.target.value });
  };

  const handleReset = () => {
    setTheme(defaultTheme);
  };

  return (
    <div className={styles.theme_settings}>
      <TextComponent text={"🎨 Customize Theme"} className={styles.labelText} />
      <TextComponent text="Pick your favorite colors for a personalized experience." divStyle={{marginTop:40}} />

      <div className={styles.color_picker_group}>
        <div className={styles.color_picker}>
          <TextComponent text="Primary Color" />
          <div className={styles.color_box}>
            <input
              type="color"
              id="primary"
              name="primary"
              value={theme.primary}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className={styles.color_picker}>
          <TextComponent text="Menu Active Color" />
          <div className={styles.color_box}>
            <input
              type="color"
              id="menuactive"
              name="menuactive"
              value={theme.menuactive}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* <div className={styles.color_picker}>
          <TextComponent text="🎨 Secondary Color" />
          <div className={styles.color_box}>
            <input
              type="color"
              id="secondary"
              name="secondary"
              value={theme.secondary}
              onChange={handleChange}
            />
          </div>
        </div> */}
      </div>

      {/* Reset Button */}
      <button className={styles.reset_btn} onClick={handleReset}>
        Reset to Default
      </button>
    </div>
  );
};

export default ThemeColor;
